/*
 * _customled-slideshow-a11y.js  (M9.1, 2026-10-12) - owned add-on for the vendor
 * <slideshow-component> (assets/slideshow.js), no vendor edit.
 *
 * WCAG 2.2.2 Pause, Stop, Hide: an auto-rotating hero must offer a pause control.
 *  - Adds an always-visible Pause/Play toggle (aria-pressed) in the hero's bottom corner
 *    (the vendor dot strip is opacity:0 on desktop until hover, so the toggle lives outside it).
 *  - prefers-reduced-motion: reduce  -> starts paused (user can press Play).
 *  - Keyboard focus inside the carousel pauses it; leaving resumes (unless user-paused).
 *  - The vendor resumes on mouseleave and on every slide change (handleSlideChange ->
 *    startProgressBar). Both paths are wrapped so a user pause STICKS.
 * Strings come from window.__clSlideshowA11y (rendered by _customled-stylesheets.liquid).
 * Only touches components with data-autoplay="true"; otherwise does nothing.
 */
(function () {
  'use strict';
  var S = window.__clSlideshowA11y || { pause: 'Pause slideshow', play: 'Play slideshow' };
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function setup(c) {
    if (c.__clA11y || c.getAttribute('data-autoplay') !== 'true') return;
    if (!c.autoPlayEnabled || !c.flickity) return; // not ready yet (or autoplay off / design mode)
    c.__clA11y = true;
    var userPaused = reduce, focusInside = false;

    function hold() { return userPaused || focusInside; }
    function pause() { c.paused = true; if (c.pauseAllVideos) c.pauseAllVideos(); }
    function resume() {
      if (hold()) return;
      c.paused = false;
      c.start = performance.now() - ((c.progressBarWidth || 0) / 100) * c.autoPlaySpeed;
      window.requestAnimationFrame(c.animateProgressBar);
      if (c.flickity && c.playSlideVideo) c.playSlideVideo(c.flickity.selectedIndex);
    }

    // Slide changes (dots, swipe, auto-advance) call startProgressBar(); honor a hold.
    var origStart = c.startProgressBar;
    c.startProgressBar = function () { if (hold()) { c.paused = true; return; } return origStart.apply(c, arguments); };
    // Vendor mouseleave resumes unconditionally; this listener runs after it and re-holds.
    if (c.slideshow) c.slideshow.addEventListener('mouseleave', function () { if (hold()) c.paused = true; });

    c.addEventListener('focusin', function () { focusInside = true; pause(); });
    c.addEventListener('focusout', function (e) {
      if (e.relatedTarget && c.contains(e.relatedTarget)) return;
      focusInside = false; resume();
    });

    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'cl-slideshow-toggle';
    function render() {
      btn.setAttribute('aria-pressed', userPaused ? 'true' : 'false');
      btn.setAttribute('aria-label', userPaused ? S.play : S.pause);
      btn.classList.toggle('is-paused', userPaused);
    }
    btn.addEventListener('click', function () {
      userPaused = !userPaused; render();
      if (userPaused) pause(); else { focusInside = false; resume(); }
    });
    render();
    c.appendChild(btn);
    if (userPaused) pause();
  }

  function scan() {
    var list = document.querySelectorAll('slideshow-component[data-autoplay="true"]');
    var pending = false;
    for (var i = 0; i < list.length; i++) { setup(list[i]); if (!list[i].__clA11y && list[i].autoPlayEnabled !== false) pending = true; }
    return pending;
  }
  // Flickity initializes asynchronously (and may be deferred until near the viewport): retry briefly.
  var tries = 0;
  (function tick() { if (scan() && ++tries < 40) setTimeout(tick, 250); })();
  window.addEventListener('scroll', function onScroll() { if (!scan()) window.removeEventListener('scroll', onScroll); }, { passive: true });
})();
